<template>
  <div>
    车辆
  </div>
</template>

<script>

export default {
  name: 'Cl',
  components: {
    // sideMenu,
    // Header
  },
  data() {
    return {

    }
  },
  created: function() {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>
